import { useMemo } from 'react';
import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';
function useEmotionStyles(styles, props) {
    var theme = useTheme();
    var classes = styles(theme, props);
    return useMemo(function () {
        var classNameMap = Object.fromEntries(Object.entries(classes).map(function (_a) {
            var key = _a[0], value = _a[1];
            return [key, css(value)];
        }));
        return classNameMap;
    }, [classes]);
}
export default useEmotionStyles;
